import { Component, EventEmitter, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { tap } from 'rxjs/operators';
import { NotificationDataInstanceToken, NotificationDataInterface } from '../../interfaces/notification-data.interface';
import { NotificationModel } from '../../models/low-level/notification.model';
import { EscalationModel } from './escalation.model';
import { EscalationInterface, EscalationInstanceToken } from '../../interfaces/escalation.interface';

@Component({
    selector: 'pace-core-escalation',
    templateUrl: './escalation.component.html',
    styleUrls: ['./escalation.component.scss'],
    standalone: false,
})
export class EscalationComponent implements OnInit {
    @Input()
    public notification: NotificationModel;

    public model: EscalationModel;
    public formChildren: FormArray;
    public escalationForm: FormGroup;
    public isLoading = false;
    public modalResult = new EventEmitter<boolean>();
    public escalationMessage: string;
    public notificationDetails: string;
    public constructor(
        private readonly translate: TranslateService,
        public readonly modalInstance: BsModalRef,
        @Inject(NotificationDataInstanceToken) private readonly notificationService: NotificationDataInterface,
        @Inject(EscalationInstanceToken) private readonly escalationService: EscalationInterface,
        private readonly formBuilder: FormBuilder,
    ) {}

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.escalationForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
        this.model = new EscalationModel(this.notification.identifier);

        const osrStatus = this.notificationService.getStatus(this.notification);

        const diffTimeString = osrStatus.startTime.fromNow();

        this.notificationDetails = <string>this.translate.instant('ESCALATION_NOTIFICATION_DETAIL', {
            notificationNo: this.notification.identifier.qmNum,
            customerName: this.notification.address.name1.value,
        });

        this.escalationMessage = <string>this.translate.instant('ESCALATION_TIMEOUT_TEXT', {
            timeDiff: diffTimeString,
        });
    }

    /**
     * This function sends the request to the backend for escalation
     */
    public escalateToRSC(): void {
        this.isLoading = true;

        this.escalationService
            .saveEscalationStatus(this.model, this.notification)
            .pipe(
                tap(() => {
                    this.modalResult.next(true);
                    this.modalResult.complete();
                    this.modalInstance.hide();
                    this.isLoading = false;
                }),
            )
            .subscribe();
    }
}
